import React from 'react';
interface HeroSectionProps {
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
}
export function HeroSection(_props: HeroSectionProps) {
  return <section className="w-full overflow-hidden bg-[#0B0B0B]" aria-label="NOIZA" data-id="element-2398" data-mp="34rdvjywuehj2">
      <img src="https://cdn.magicpatterns.com/uploads/4ivJbLBZYcrUiKx8MpoPw6/IMG_5634.png" alt="NOIZA — Agosto, mes de las madres" className="block h-auto w-full max-h-[78vh] object-cover object-center" data-id="element-2399" data-mp="2qtp7ki7hau9s" />
    </section>;
}